import { createSignal } from "solid-js";
export const [running, setRunning] = createSignal(false);
